module.exports = __webpack_public_path__ + "img/SSLRLOC.b644671a.svg";